import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';

import memoizedPartial from 'shared/utils/memoized-partial';

import { getVideosGroupedByIds } from 'shared/selectors/videos';

import { openVideoPage } from 'widget/redux/client/actions/mobile-overlay-openners/main-openners';

import MobileCarousel from 'widget/components/mobile-carousel/mobile-carousel';
import FakePlayer from './fake-player';
import firstTimeTrackAnimation from 'widget/components/players-list-slidable/first-time-track-animation';

import styles from './players-list-slidable.styl';


/*
 This component is performance dependable. PLease avoid @ui because it leads to extra render while swiping
 */
@connect(state => ({
  videoIds: state.lazyVideoLists.mobileWidget.videoIds,
  videoByIds: getVideosGroupedByIds(state),
}), {
  onEnded: openVideoPage,
})
@firstTimeTrackAnimation
export default class PlayersListSlidable extends React.Component {

  static propTypes = {
    videoIds: React.PropTypes.array,
    videoByIds: React.PropTypes.object,
    onEnded: React.PropTypes.func,
    onUserStartedTracking: React.PropTypes.func,
    className: React.PropTypes.string,
    trackClassName: React.PropTypes.string,

    loadMore: React.PropTypes.func,
    onPaused: React.PropTypes.func,
    paused: React.PropTypes.bool,
    itemWidth: React.PropTypes.number,
    itemHeight: React.PropTypes.number,
    canShowChannelCover: React.PropTypes.bool,
    onCurrentSlideChanged: React.PropTypes.func,
    onPlayClick: React.PropTypes.func,
    onPlayStart: React.PropTypes.func,
    onMemberSignUp: React.PropTypes.func,
    selectedVideoId: React.PropTypes.string,
  };

  static defaultProps = {
    onPlayClick: _.noop,
    onPlayStart: _.noop,
    onMemberSignUp: _.noop,
    onCurrentSlideChanged: _.noop,
    onEnded: _.noop,
    onPaused: _.noop,
  };

  @autobind
  afterChange(leftVisibleSlideIndex) {
    const { loadMore, onCurrentSlideChanged } = this.props;
    const slidesShown = leftVisibleSlideIndex + 3;

    loadMore(slidesShown);
    onCurrentSlideChanged(leftVisibleSlideIndex);
  }

  get selectedIndex() {
    const { videoIds, selectedVideoId } = this.props;

    const selectedVideoIndex = _.indexOf(videoIds, selectedVideoId);
    return selectedVideoIndex < 0 ? 0 : selectedVideoIndex;
  }

  @autobind
  setPaused(index) {
    if (this.selectedIndex === index) {
      this.props.onPaused();
    }
  }

  renderItem(videoItem, index) {
    const {
      onPlayStart, onPlayClick, canShowChannelCover, itemWidth, itemHeight, paused, onMemberSignUp,
    } = this.props;

    const isCurrentVideo = this.selectedIndex === index;
    const useChannelCoverIfPossible = canShowChannelCover && isCurrentVideo;
    const pausedForThisVideo = isCurrentVideo ? paused : true;

    return (
      <FakePlayer videoItem={videoItem}
                  className={styles['overlay-item-topmost']}
                  useChannelCoverIfPossible={useChannelCoverIfPossible}
                  onPause={memoizedPartial(this.setPaused, index)}
                  paused={pausedForThisVideo}
                  itemWidth={itemWidth}
                  itemHeight={itemHeight}
                  onPlayClick={onPlayClick}
                  onPlayStart={onPlayStart}
                  onMemberSignUp={onMemberSignUp} />
    );
  }

  render() {
    const {
      videoIds, videoByIds, className, itemHeight, trackClassName, onUserStartedTracking,
    } = this.props;

    const partialList = _.map(videoIds, (videoId, index) => (
      <div key={videoId}>
        {this.renderItem(videoByIds[videoId], index)}
      </div>
    ));

    return (
      <MobileCarousel afterChange={this.afterChange}
                      getHeight={_.constant(itemHeight)}
                      showButtons={false}
                      onUserStartedTracking={onUserStartedTracking}
                      slidesToShow={1}
                      trackClassName={trackClassName}
                      className={className}
                      initialSlide={this.selectedIndex}>
        {partialList}
      </MobileCarousel>
    );
  }
}




// WEBPACK FOOTER //
// ./src/widget/components/players-list-slidable/players-list-slidable.js